






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'
import {InputCentroDeCustoSchema} from '@/schema/resource/CentroDeCusto/InputCentroDeCustoSchema'

@Component
export default class PersistCentroDeCustoView extends Vue {
  @Prop() id1?: string
  @Prop() id2?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCentroDeCustoSchema()
  centroDeCusto = new CentroDeCusto()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
    this.schema.collectionCarga.listCarga()
  }

  async populate() {
    const id1 = Number(this.id1) || null
    const id2 = Number(this.id2) || null

    if (id1 && id2) {
      await this.centroDeCusto.getCentroDeCusto(id1, id2)
    }

    $.await.done('getCentroDeCusto')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.centroDeCusto.persistCentroDeCusto()
    await Helper.successAndPush(
      'system.success.persist',
      '/centro-de-custo/list'
    )
  }
}
